<template>
  <div class="newsList ztzl">
    <!-- 专题专栏 -->
    <div class="content">
      <div class="chanpincon">
        <div class="inner">
          <!-- 导航 -->
          <div class="childnav">
            <div class="desc">
              <img src="/statics/image/index/icon.png" alt />
              <span>{{cateact.title}}</span>
            </div>
            <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item,index) in s_cates" :key="index" :name="item.id.toString()">
                <a
                  href="javascript:scroll(0,0)"
                  slot="label"
                  v-if="item.title"
                  :style="!item.display?'display: none;':''"
                >{{item.title}}</a>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- 右侧内容 -->
          <div class="news_right">
            <!-- 面包屑导航 -->
            <div class="mbnav">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">
                  <img class="homeIcon" src="/statics/image/index/home.png" alt />
                  首页
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{breadName}}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <!-- <div class="zt_list">
              <div
                class="zt_item"
                v-for="(item,index) in zlS_cates"
                :key="index"
                @click="toInfo(item.id)"
                :style="(!item.display)||(item.id=='131')?'display:none':''"
              >
                <img class="ztpic" :src="adddom(item.thumb)" alt="pic"/>
              </div>
            </div>-->
            <div class="news_right" v-if="article">
              <div class="gg_list">
                <div
                  class="gg_item"
                  v-for="(item,index) in article.articlelist"
                  :key="index"
                  @click="toInfo(nowid,item,item.article_id,item.link_flag)"
                >
                  <div class="gg">
                    <span>[公告] {{item.article_title}}</span>
                  </div>
                  <div class="time">
                    <span>{{item.publish_at}}</span>
                    <img src="/statics/image/index/gg_jiantou.png" alt />
                  </div>
                </div>
              </div>

              <!-- 分页 -->
              <div class="fenye clearfix" v-if="article.articlelist.length!=0 && activeName!=5464">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page.sync="currentPage"
                  :page-size="pages.size"
                  layout="prev, pager, next, jumper"
                  :total="newsTotal"
                  prev-text="上一页"
                  next-text="下一页"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabPosition: "left", //导航对齐方式
      activeName: null,
      nowid: "",
      s_cates: [], //二级分类
      zlS_cates: [], //专栏二级分类
      cateact: { title: "" },
      article: { articlelist: [] },
      fromName: "",
      xqIndex: "", //新区要闻下标
      currentPage: 1, //当前页数
      pages: {
        page: 1,
        size: 10
      },
      newsTotal: 0, //总条数
      breadName: "",
      topvalue: ""
    };
  },
  created() {
    if (localStorage.getItem("topvalue")) {
      this.topvalue = localStorage.getItem("topvalue");
    }
    this.nowid = this.$route.query.cate_id;
    this.getNav();
    this.getArticlelist();
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        // console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    // 文章列表
    getArticlelist() {
      var that = this;
      var ps = {
        cate_id: that.$route.query.cate_id,
        page: that.pages.page,
        size: that.pages.size
      };
      if (that.topvalue && that.topvalue != "") {
        ps.keyword = that.topvalue;
      } else {
        ps.keyword = "";
      }
      that.$api.index.articlelist(ps).then(function(res) {
        if (res.code == 200) {
          that.article = res.result;
          if (
            that.article.articlelist.length == 0 &&
            that.activeName != "5464"
          ) {
            that.$message({
              message: "搜索结果为空！",
              type: "warning"
            });
          }
          that.newsTotal = res.result.total * 1;
        }
      });
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      // console.log(val);
      this.pages.page = val;
      this.getArticlelist();
      $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
    },
    // 获取导航
    getNav() {
      var that = this;
      that.$api.index.catelist({}).then(function(res) {
        if (res.code == 200) {
          for (var i in res.result.all_cate) {
            if (res.result.all_cate[i].id == 12) {
              that.xqIndex = i;
            }
            if (res.result.all_cate[i].id == 29) {
              that.zlS_cates = res.result.all_cate[i].s_cates;
            }
            if (res.result.all_cate[i].id == that.nowid) {
              that.breadName = res.result.all_cate[i].title;
            }
          }
          that.cateact = res.result.all_cate[that.xqIndex];
          that.s_cates = res.result.all_cate[that.xqIndex].s_cates
            ? res.result.all_cate[that.xqIndex * 1].s_cates
            : [];
        }
      });
    },
    // 导航选中触发
    handleClick(tab, event) {
      if (localStorage.getItem("topvalue")) {
        localStorage.removeItem("topvalue");
      }
      if (localStorage.getItem("tabvalue")) {
        localStorage.removeItem("tabvalue");
      }
      // console.log(tab.name);
      this.$router.push({
        path: "/xqNews",
        query: {
          id: 12,
          index: this.xqIndex,
          dhid: tab.name
        }
      });
    },
    // 点击跳转到新区要闻详情
    toInfo(cate_id, item, id, flex) {
      if (flex == 0) {
        // console.log("跳", this.nowindex);
        this.$router.push({
          path: "/xqNews_detail",
          query: {
            cate_id,
            id: id,
            index: this.nowindex
            // erId: this.activeName
          }
        });
      } else {
        window.open(item.url);
      }
    }
  },
  watch: {
    $route(to, from) {
      localStorage.removeItem("topvalue");
      this.topvalue = "";
      if (to.name != "xqNews_detail" && from.name != "xqNews_detail") {
        this.currentPage = 1; //当前页数
        this.pages.page = 1;
        this.getNav();
        this.getArticlelist();
      }
    }
  }
};
</script>

<style>
</style>